import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type RegisterNewUserMutationVariables = Types.Exact<{ [key: string]: never }>;

export type RegisterNewUserMutation = {
	__typename?: 'Mutation';
	registerNewUser: { __typename?: 'RegisterPayload'; loginId: string };
};

export const RegisterNewUserDocument = gql`
	mutation RegisterNewUser {
		registerNewUser {
			loginId
		}
	}
`;
